import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const HeroSection: React.FC = () => {
  const heroImage = `${process.env.PUBLIC_URL}/img/journaling-bg.png`;
  return (
    <section className="relative py-12 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#D4A5A5]/10 to-[#9CAF88]/10" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }}>
            <span className="font-sans text-sm text-[#D4A5A5] font-medium tracking-wider uppercase mb-4 block">Welcome</span>
            <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-semibold text-[#3D3D3D] leading-tight mb-6">
              Where Women
              <br />
              <span className="text-[#D4A5A5]">Get Connected</span>
            </h1>
            
            <p className="font-sans text-lg text-[#3D3D3D]/70 leading-relaxed mb-8 max-w-lg">
              You belong here. Welcome!
              <br />
              Not Junk Journaling is a place to connect, share what God is doing in your life, and encourage one another. Sign up below to receive free Bible journaling pages and hear about upcoming workshops and news.
              <br />
              We'd love to see you at our next workshop. There's a spot for you, and your story may be just the encouragement another woman needs.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link to="/events">
                <button className="bg-[#3D3D3D] hover:bg-[#2D2D2D] text-white px-6 py-3 rounded-full font-sans text-sm leading-none inline-flex items-center justify-center whitespace-nowrap">
                  <span className="inline-block">View Upcoming Events and Worshops</span>
                  <ArrowRight className="ml-1.5 w-4 h-4 inline-block group-hover:translate-x-1 transition-transform" />
                </button>
              </Link>
              {/* <Link to="/subscriptions">
                <button className="border border-[#D4A5A5] text-[#D4A5A5] hover:bg-[#D4A5A5]/10 px-6 py-3 rounded-full font-sans text-sm leading-none">Join the Membership</button>
              </Link> */}
            </div>
          </motion.div>

          <motion.div initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6, delay: 0.2 }} className="relative">
            <div className="relative">
              <img src={heroImage} alt="Journaling" className="rounded-3xl shadow-2xl w-full" />
              <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-[#D4A5A5]/20 rounded-full blur-2xl" />
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-[#9CAF88]/20 rounded-full blur-2xl" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
